import React from 'react'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'
import {ContentNotes} from '../../Molecules/BaseContentBlocks/ContentNotes'
import {MembersPageTemplate} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {Spacer} from '../../../../Common/Components/Spacer'
import {useTranslation} from 'react-i18next'

export function MembersEditMailSendCompletePage(): JSX.Element {
  const {t} = useTranslation('member')

  return (
    <MembersPageTemplate>
      <PageTitle>メールアドレス変更URL発行</PageTitle>
      <ContentBlock data-testid={'block-notification'}>
        <ContentTitle>メール送信完了</ContentTitle>
        <ContentTopMessage>
          ご入力いただいたメールアドレスにメールアドレス変更URLを送信しました。<br/>
          届いたメールに記載されているURLよりメールアドレス変更手続きを完了させてください。<br/>
          メールに記載されているURLの有効期限は3時間となっています。
        </ContentTopMessage>
        <Spacer mt={'18px'}>
          <ContentNotes
            notes={[
              'ご変更手続きは、まだ完了していませんのでご注意ください。',
              t('メールアドレス変更URL発行.注記 メール受信設定'),
            ]}
            data-testid={'content-notes'}
          />
        </Spacer>
      </ContentBlock>
    </MembersPageTemplate>
  )
}
